// extracted by mini-css-extract-plugin
var _1 = "M6ppsOUvHMi2aoNDar1d";
var _2 = "t_vMoKdCtghQVTX8CDYd";
var _3 = "v_h3SbhANKnG1G0OrMtC";
export { _1 as "input", _2 as "label", _3 as "root" }
